import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { GetConfigZoppyResponse } from '../../responses/integracao-zoppy/get-config-zoppy.response';
import { UpdateConfigZoppyRequest } from '../../requests/integracao-zoppy/update-config-zoppy.request';

@Injectable({
    providedIn: 'root',
})
export class TipoLogService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiIntegracaoZoppy}Config`;

    public getTiposLog(): Observable<any> {
        return this.httpClient
            .get<any>(`${environment.urlApiIntegracaoZoppy}TipoLog`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
